import React from "react";
export var FooterSocialIcon = function FooterSocialIcon(param) {
  var icon = param.icon;
  var Icon = null;
  switch (icon) {
    case "facebook":
      Icon = FacebookIcon;
      break;
    case "instagram":
      Icon = InstagramIcon;
      break;
    case "linkedin":
      Icon = LinkedInIcon;
      break;
    case "tiktok":
      Icon = TikTokIcon;
      break;
    case "twitter":
      Icon = TwitterIcon;
      break;
    case "youtube":
      Icon = YoutubeIcon;
      break;
    case "blog":
      Icon = BlogIcon;
      break;
    default:
      return null;
  }
  return /*#__PURE__*/React.createElement(Icon, null);
};
var FacebookIcon = function FacebookIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 18,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.025 6.484H6.006V4.471a1.007 1.007 0 0 1 1.006-1.004H8.02V.95H6.006a3.019 3.019 0 0 0-3.019 3.019v2.517H.975v2.517h2.012v8.047h3.02V9h2.012l1.006-2.516Z"
  }));
};
var InstagramIcon = function InstagramIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.018.95H5.981A5.035 5.035 0 0 0 .95 5.981v6.038a5.035 5.035 0 0 0 5.031 5.03h6.037a5.035 5.035 0 0 0 5.032-5.03V5.98A5.035 5.035 0 0 0 12.018.95Zm3.522 11.069a3.526 3.526 0 0 1-3.521 3.521H5.98a3.526 3.526 0 0 1-3.522-3.521V5.98A3.526 3.526 0 0 1 5.981 2.46h6.037a3.526 3.526 0 0 1 3.522 3.522v6.038Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9 4.731a4.27 4.27 0 1 0 0 8.538 4.27 4.27 0 0 0 0-8.538Zm0 6.937a2.668 2.668 0 1 1 0-5.337 2.668 2.668 0 0 1 0 5.337ZM13.435 5.25a.57.57 0 1 0-.261-1.108.57.57 0 0 0 .261 1.108Z"
  }));
};
var LinkedInIcon = function LinkedInIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.901 5.632h-3.6V16.7h3.6V5.63ZM13.708 5.762c-.039-.012-.074-.025-.115-.036a1.439 1.439 0 0 0-.146-.028 3.228 3.228 0 0 0-.646-.066 5.002 5.002 0 0 0-3.87 2.116V5.632H5.333V16.7h3.6v-6.038s2.721-3.79 3.87-1.006V16.7H16.4V9.23a3.59 3.59 0 0 0-2.693-3.47ZM2.062 4.122a1.76 1.76 0 1 0 0-3.521 1.76 1.76 0 0 0 0 3.521Z"
  }));
};
var TikTokIcon = function TikTokIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.518 6.902v-2.69c-1.26 0-2.22-.336-2.84-.99a4.215 4.215 0 0 1-1.01-2.67V.357L8.127.296V11.22a2.367 2.367 0 1 1-1.534-2.656V5.959a4.906 4.906 0 1 0 4.063 4.238V5.865a6.857 6.857 0 0 0 3.864 1.037Z"
  }));
};
var TwitterIcon = function TwitterIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 18,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.198 7.768 16.063.95h-1.39L9.579 6.87 5.513.95H.823l6.15 8.951-6.15 7.15h1.39l5.377-6.252 4.295 6.251h4.691l-6.378-9.282ZM8.294 9.98 7.67 9.09 2.713 1.997h2.134L8.85 7.72l.625.892 5.2 7.44H12.54L8.294 9.98Z"
  }));
};
var YoutubeIcon = function YoutubeIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "21",
    height: "14",
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.6662 1.56047C19.1347 0.614647 18.5577 0.440816 17.3836 0.374679C16.2089 0.29508 13.2579 0.261719 10.7014 0.261719C8.14485 0.261719 5.18741 0.295081 4.01508 0.372924C2.84451 0.440232 2.26449 0.612891 1.72779 1.55988C1.17996 2.50453 0.898438 4.13162 0.898438 6.99601V7.00596C0.898438 9.85805 1.17996 11.4969 1.72779 12.4316C2.26449 13.3774 2.83983 13.5489 4.01391 13.6285C5.18741 13.6969 8.14017 13.7373 10.7014 13.7373C13.2626 13.7373 16.2095 13.6969 17.3842 13.6296C18.5588 13.55 19.1359 13.3785 19.6668 12.4327C20.2193 11.4963 20.4985 9.85747 20.4985 7.00713V6.99718C20.499 4.13163 20.2199 2.50453 19.6662 1.56047ZM14.3731 6.99923L8.24805 10.6748V3.32422L14.3731 6.99923Z",
    fill: "currentColor"
  }));
};
var BlogIcon = function BlogIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31 22",
    width: "21",
    className: "h-auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.319 8.477q0 2.417-1.062 4.431-1.062 1.978-2.49 3.443-1.465 1.501-3.223 2.71-1.758 1.171-2.82 1.72l-1.245-2.16q1.502-.879 2.857-1.794 1.391-.952 2.124-1.795.988-1.098 1.574-2.27.586-1.209.733-3.15H9.009q-2.307 0-3.589-1.171T4.138 5.18q0-1.501 1.172-2.82 1.172-1.354 3.186-1.354 3.113 0 4.468 2.087 1.355 2.05 1.355 5.383zm13.55 0q0 2.417-1.062 4.431-1.062 1.978-2.49 3.443-1.465 1.501-3.223 2.71-1.758 1.171-2.82 1.72l-1.245-2.16q1.502-.879 2.857-1.794 1.391-.952 2.124-1.795.988-1.098 1.574-2.27.586-1.209.733-3.15h-1.758q-2.307 0-3.589-1.171-1.282-1.172-1.282-3.26 0-1.501 1.172-2.82 1.172-1.354 3.186-1.354 3.113 0 4.468 2.087 1.355 2.05 1.355 5.383z",
    fill: "currentColor"
  }));
};